import { ReactNode, useCallback, useMemo } from "react";
import { useDispatch } from "react-redux";

import { HANDBOOK_SHOW_MORE_LIMIT, TEMPLATE_APPLY_EDITINGS_LOADER_TEXT } from "pages/HandBook/const";
import { useCheckAll } from "pages/HandBook/hooks/useCheckAll";
import { HANDBOOK_TEMPLATE_LVL, handBookActions } from "pages/HandBook/model/slice";
import { IHandBookTemplate } from "pages/HandBook/model/types";
import TemplateBlurLoader from "pages/HandBook/ui/TemplateBlurLoader/TemplateBlurLoader";
import { CreateHandbookTemplate } from "pages/HandBook/widgets/CreateHandbook/CreateHandbookTemplate";
import CreateHandbookTemplateBtn from "pages/HandBook/widgets/CreateHandbook/CreateHandbookTemplateBtn";

import HandBooksTemplatesRow from "../../HandBooksTemplatesRow";
import icon from "./../../../../assets/handbook.svg";
import { useHandbookTemplates } from "./useHandbookTemplates";
import { useHandbookTemplatesColumns } from "./useHandbookTemplatesColumns";
import TableReusableHead, { TableReusableHeaderCell } from "shared/ui/dataDisplay/TableReusable/TableReusableHead";
import Checkbox from "shared/ui/inputs/Checkbox/Checkbox";
import ListWrapper from "shared/ui/layout/ListWrapper/ListWrapper";
import RowGrid from "shared/ui/layout/RowGrid/RowGrid";

const formColPercents = [3, 97];

const HandbookTemplates = () => {
  const {
    hasListFilters,
    displayTemplates,
    isLoading,
    isLoadingMore,
    isLoadingApplyEditings,
    total,
    isEditing,
    filter,
    onChangeFilter,
    onRowClick,
    onPagination,
  } = useHandbookTemplates();

  const { allChecked, handleToggleAllChecked } = useCheckAll({
    lvl: HANDBOOK_TEMPLATE_LVL.TEMPLATES,
    displayItems: displayTemplates,
  });

  const { columns, colPercents } = useHandbookTemplatesColumns();

  return (
    <>
      <ListWrapper
        data={displayTemplates}
        dataMapper={(item: IHandBookTemplate) => (
          <HandBooksTemplatesRow
            item={item}
            key={item.id}
            colPercents={colPercents}
            formColPercents={formColPercents}
            columns={columns}
            nameFieldPlaceholder="Введите название шаблона"
            onRowClick={() => onRowClick(item.id)}
          />
        )}
        header={
          <TableReusableHead isSticky isNoDefaultGridCols>
            <RowGrid percents={colPercents}>
              {isEditing && (
                <TableReusableHeaderCell isCentered>
                  <Checkbox onCheck={handleToggleAllChecked} checked={allChecked} noMargin />
                </TableReusableHeaderCell>
              )}
              {columns.map((el) => (
                <TableReusableHeaderCell
                  key={el.header.title}
                  isCentered={el.isCentered}
                  filterType={el.header.filterType ? el.header.filterType : el.header.filterName ? "text" : undefined}
                  filterField={el.header.filterName}
                  onChangeFilter={onChangeFilter}
                  filterTitle={el.header.title}
                  isLast={el.isLast}
                  filterOptions={el.header.filterOptions}
                  isRighted={el.isRighted}
                  rangeStartField={el.header.rangeStartField}
                  rangeEndField={el.header.rangeEndField}
                  isDebouncedFilterApply
                >
                  {el.header.title}
                </TableReusableHeaderCell>
              ))}
            </RowGrid>
          </TableReusableHead>
        }
        placeholderProps={{ img: icon, text: hasListFilters ? "Нет сведений" : "Добавьте шаблон", fullHeight: false }}
        total={total}
        isLoading={isLoading}
        isLoadingMore={isLoadingMore}
        filter={filter}
        onPagination={onPagination}
        paginationLimit={HANDBOOK_SHOW_MORE_LIMIT}
        postfix={
          !isLoading && (
            <>
              <CreateHandbookTemplate />
              <CreateHandbookTemplateBtn text="Добавить шаблон" />
            </>
          )
        }
      />
      {isLoadingApplyEditings && <TemplateBlurLoader text={TEMPLATE_APPLY_EDITINGS_LOADER_TEXT} />}
    </>
  );
};

export default HandbookTemplates;

//TODO доработать под нормальное реиспользование и перенести в shared
export interface ICommonColumn<T extends Record<string, any>> {
  header: {
    title: string;
    filterName?: string;
    filterType?: "select" | "datesRange";
    filterOptions?: any[];
    rangeStartField?: string;
    rangeEndField?: string;
  };
  isCentered?: boolean;
  isNoBreak?: boolean;
  isLast?: boolean;
  isRighted?: boolean;
  render: (item: T) => ReactNode;
}
